(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["circuit-track"] && !Shopify.designMode) return;
  try {
    
(function () {
  function hexToRgb(h){h=(h||'#ff8a1a').replace('#','');if(h.length===3)h=h[0]+h[0]+h[1]+h[1]+h[2]+h[2];var n=parseInt(h,16);return [(n>>16)&255,(n>>8)&255,n&255];}

  function initTrack(sec){
    if (sec.dataset.circuitReady === '1') return;
    sec.dataset.circuitReady = '1';
    var road=sec.querySelector('.circuit__road'),
        car=sec.querySelector('.circuit__car'),          // the single positioned box (a or div)
        img=sec.querySelector('.circuit__carimg'),
        sh=sec.querySelector('.circuit__shadow'),
        pins=sec.querySelectorAll('.circuit__pin'),
        fx=sec.querySelector('.circuit__fx');
    if(!road) return;
    var VBW=1200, VBH=520, LEN=road.getTotalLength();
    var tilt=(parseFloat(sec.getAttribute('data-tilt'))||45)/100, speed=parseFloat(sec.getAttribute('data-speed'))||230;
    var sparksOn = sec.getAttribute('data-sparks')==='true';
    var col = hexToRgb(sec.getAttribute('data-spark'));
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches, dist=0, last=performance.now();
    var carPx=parseFloat(getComputedStyle(sec).getPropertyValue('--ct-carw'))||200;
    var fctx = fx ? fx.getContext('2d') : null, sparks=[], MAX=60, lastX=0, lastY=0, lastAng=0, raf=null;

    function sizeFx(){ if(!fx) return; var W=sec.clientWidth,H=sec.clientHeight,dpr=Math.min(window.devicePixelRatio||1,1.5); fx.width=W*dpr; fx.height=H*dpr; fctx.setTransform(dpr,0,0,dpr,0,0); }
    function svgMap(){
      // map viewBox coords -> screen px using the actual rendered SVG box (works with preserveAspectRatio)
      var svg=sec.querySelector('.circuit__svg'), r=svg.getBoundingClientRect();
      var stage=sec.querySelector('.circuit__stage')||sec, host=stage.getBoundingClientRect();
      var sc=Math.max(r.width/VBW, r.height/VBH);           // 'slice' = cover
      var offX=r.left-host.left+(r.width-VBW*sc)/2, offY=r.top-host.top+(r.height-VBH*sc)/2;
      return function(px,py){return {x:offX+px*sc,y:offY+py*sc,s:sc};};
    }
    function clampX(x){var pad=54,W=sec.clientWidth;return Math.max(pad,Math.min(W-pad,x));}
    function placePins(){var m=svgMap();
      var stage=sec.querySelector('.circuit__stage')||sec;
      var dY=stage.getBoundingClientRect().top-sec.getBoundingClientRect().top;
      var dX=stage.getBoundingClientRect().left-sec.getBoundingClientRect().left;
      pins.forEach(function(pn){
      var d=(parseFloat(pn.getAttribute('data-pos'))||0)/100*LEN;var p=road.getPointAtLength(d);var q=m(p.x,p.y);
      pn.style.left=clampX(q.x+dX)+'px';pn.style.top=(q.y+dY)+'px';});}
    function place(d){var m=svgMap();var p=road.getPointAtLength(d),p2=road.getPointAtLength((d+2)%LEN);
      var a=m(p.x,p.y),b=m(p2.x,p2.y);
      var dx=b.x-a.x,dy=b.y-a.y,ang=Math.atan2(dy,dx)*180/Math.PI*tilt,x=a.x,y=a.y;
      if(car){var ch=car.offsetHeight||0;var lift=ch*0.40;car.style.transform='translate('+x+'px,'+(y-lift)+'px) translate(-50%,-50%) rotate('+ang+'deg)';}
      if(sh)sh.style.transform='translate('+x+'px,'+(y+2)+'px) translate(-50%,-50%)';
      lastX=x; lastY=y; lastAng=Math.atan2(dy,dx);}

    function emit(){if(sparks.length>=MAX)return;var bx=lastX-Math.cos(lastAng)*carPx*0.42,by=lastY-Math.sin(lastAng)*carPx*0.42-4;
      for(var i=0;i<2;i++){var sp=130+Math.random()*140;sparks.push({x:bx,y:by,vx:-Math.cos(lastAng)*sp+(Math.random()-0.5)*70,vy:-Math.sin(lastAng)*sp-Math.random()*60,age:0,life:0.5+Math.random()*0.35,sz:1+Math.random()*2});}}
    function step(dt){for(var i=sparks.length-1;i>=0;i--){var s=sparks[i];s.age+=dt;if(s.age>=s.life){sparks.splice(i,1);continue;}s.vy+=480*dt;s.x+=s.vx*dt;s.y+=s.vy*dt;}}
    function draw(){if(!fctx)return;var W=sec.clientWidth,H=sec.clientHeight;fctx.clearRect(0,0,W,H);fctx.globalCompositeOperation='lighter';
      for(var i=0;i<sparks.length;i++){var s=sparks[i],t=1-s.age/s.life;fctx.globalAlpha=t;
        fctx.fillStyle='rgb('+col[0]+','+Math.floor(col[1]*(0.5+0.5*t))+','+Math.floor(col[2]*t)+')';
        fctx.beginPath();fctx.arc(s.x,s.y,s.sz,0,6.28);fctx.fill();}
      fctx.globalAlpha=1;fctx.globalCompositeOperation='source-over';}

    function loop(now){var dt=Math.min(0.05,(now-last)/1000);last=now;dist=(dist+speed*dt)%LEN;place(dist);
      if(sparksOn){emit();step(dt);draw();}
      raf=requestAnimationFrame(loop);}
    function start(){ sizeFx(); placePins(); place(0); if(reduce){place(LEN*0.16);} else if(!raf){ last=performance.now(); raf=requestAnimationFrame(loop); } }

    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ if(!raf&&!reduce){last=performance.now();raf=requestAnimationFrame(loop);} } else { if(raf){cancelAnimationFrame(raf);raf=null;} } });},{threshold:0.05});
      io.observe(sec);
    }
    if(img && !img.complete){ img.addEventListener('load', start); }
    start();
    window.addEventListener('resize',function(){sizeFx();placePins();place(dist);});
  }
  function boot(){ document.querySelectorAll('[data-circuit]').forEach(initTrack); }
  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SRC = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  function loadThree(cb) {
    if (window.THREE) return cb();
    var ex = document.querySelector('script[data-three]');
    if (ex) { ex.addEventListener('load', cb); return; }
    var s = document.createElement('script'); s.src = SRC; s.setAttribute('data-three', '1'); s.onload = cb; document.head.appendChild(s);
  }

  function buildSupercar(THREE, paintC, rimC) {
    var car = new THREE.Group();
    var body = new THREE.MeshStandardMaterial({ color: paintC, metalness: 0.7, roughness: 0.24 });
    var dark = new THREE.MeshStandardMaterial({ color: 0x0c0e14, metalness: 0.4, roughness: 0.6 });
    var glass = new THREE.MeshStandardMaterial({ color: 0x070910, metalness: 0.5, roughness: 0.08 });
    var tyre = new THREE.MeshStandardMaterial({ color: 0x0a0b10, roughness: 0.9, metalness: 0.05 });
    var rim = new THREE.MeshStandardMaterial({ color: rimC, metalness: 1.0, roughness: 0.2 });
    var tail = new THREE.MeshStandardMaterial({ color: 0xff2233, emissive: 0xff2233, emissiveIntensity: 1.0 });
    var head = new THREE.MeshStandardMaterial({ color: 0xffffff, emissive: 0xffffff, emissiveIntensity: 0.6 });
    function box(w, h, d, m) { return new THREE.Mesh(new THREE.BoxGeometry(w, h, d), m); }
    function add(w, h, d, m, x, y, z, rz) { var e = box(w, h, d, m); e.position.set(x, y, z); if (rz) e.rotation.z = rz; car.add(e); return e; }
    add(4.0, 0.16, 1.7, dark, 0, 0.28, 0);
    add(3.2, 0.34, 1.66, body, 0, 0.5, 0);
    add(1.5, 0.16, 1.6, body, 1.35, 0.52, 0, 0.13);
    add(0.7, 0.12, 1.5, body, 2.05, 0.42, 0);
    add(1.5, 0.4, 1.78, body, -1.05, 0.52, 0);
    add(0.8, 0.16, 1.66, body, -1.7, 0.6, 0, -0.12);
    add(1.5, 0.34, 1.2, glass, -0.05, 0.86, 0);
    add(0.5, 0.4, 1.15, glass, 0.62, 0.82, 0, -0.7);
    add(1.0, 0.06, 1.16, body, -0.15, 1.04, 0);
    add(0.9, 0.24, 0.12, dark, -0.7, 0.5, 0.84);
    add(0.9, 0.24, 0.12, dark, -0.7, 0.5, -0.84);
    add(2.4, 0.1, 0.1, dark, 0, 0.34, 0.84);
    add(2.4, 0.1, 0.1, dark, 0, 0.34, -0.84);
    add(0.6, 0.06, 1.7, dark, 2.0, 0.3, 0);
    add(0.5, 0.14, 1.7, dark, -1.95, 0.34, 0);
    add(0.22, 0.05, 1.8, dark, -2.0, 1.02, 0);
    add(0.08, 0.34, 0.08, dark, -1.95, 0.85, 0.6);
    add(0.08, 0.34, 0.08, dark, -1.95, 0.85, -0.6);
    add(0.06, 0.1, 0.34, head, 2.15, 0.5, 0.5);
    add(0.06, 0.1, 0.34, head, 2.15, 0.5, -0.5);
    add(0.05, 0.12, 1.3, tail, -2.02, 0.62, 0);
    var wheels = [];
    function wheel(x, z) {
      var g = new THREE.Group();
      var t = new THREE.Mesh(new THREE.CylinderGeometry(0.48, 0.48, 0.44, 26), tyre); t.rotation.x = Math.PI / 2; g.add(t);
      var r = new THREE.Mesh(new THREE.CylinderGeometry(0.3, 0.3, 0.46, 10), rim); r.rotation.x = Math.PI / 2; g.add(r);
      var cap = new THREE.Mesh(new THREE.CylinderGeometry(0.1, 0.1, 0.5, 8), dark); cap.rotation.x = Math.PI / 2; g.add(cap);
      g.position.set(x, 0.44, z); car.add(g); wheels.push(g); return g;
    }
    wheel(1.3, 0.82); wheel(1.3, -0.82); wheel(-1.35, 0.82); wheel(-1.35, -0.82);
    car.userData.wheels = wheels;
    return car;
  }

  function puffTex(THREE) {
    var c = document.createElement('canvas'); c.width = c.height = 128; var x = c.getContext('2d');
    var g = x.createRadialGradient(64, 64, 4, 64, 64, 60); g.addColorStop(0, 'rgba(255,255,255,0.5)'); g.addColorStop(1, 'rgba(255,255,255,0)');
    x.fillStyle = g; x.fillRect(0, 0, 128, 128); return new THREE.CanvasTexture(c);
  }

  function initScene(canvas, opts) {
    var car_c = new THREE.Color(opts.car || '#1E74FF');
    var rim_c = new THREE.Color(opts.rim || '#D8DBE2');
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(38, 1, 0.1, 100);
    camera.position.set(0, 3.0, 9.2); camera.lookAt(0, 1.15, 0);
    scene.add(new THREE.AmbientLight(0xffffff, 0.5));
    var key = new THREE.DirectionalLight(0xffffff, 1.3); key.position.set(4, 8, 7); scene.add(key);
    var rimL = new THREE.DirectionalLight(0x38c8ff, 0.9); rimL.position.set(-6, 3, -4); scene.add(rimL);
    var fill = new THREE.PointLight(0xffffff, 0.5); fill.position.set(3, 3, 7); scene.add(fill);

    var car = buildSupercar(THREE, car_c, rim_c);
    car.rotation.y = -0.5; car.position.set(0, 0, 0.5); scene.add(car);

    var pt = puffTex(THREE), puffs = [];
    [[-1.6, 0.5, 0.8], [-2.2, 0.75, 0.4], [-1.9, 0.45, 1.2]].forEach(function (p) {
      var s = new THREE.Sprite(new THREE.SpriteMaterial({ map: pt, transparent: true, opacity: 0.45, depthWrite: false }));
      s.position.set(p[0], p[1], p[2]); s.scale.set(1.4, 1.4, 1); car.add(s); puffs.push(s);
    });

    var sc = document.createElement('canvas'); sc.width = sc.height = 256; var sx = sc.getContext('2d');
    var sg = sx.createRadialGradient(128, 128, 10, 128, 128, 120); sg.addColorStop(0, 'rgba(0,0,0,.55)'); sg.addColorStop(1, 'rgba(0,0,0,0)');
    sx.fillStyle = sg; sx.fillRect(0, 0, 256, 256);
    var shadow = new THREE.Mesh(new THREE.PlaneGeometry(6, 3), new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(sc), transparent: true, depthWrite: false }));
    shadow.rotation.x = -Math.PI / 2; shadow.position.y = 0.02; scene.add(shadow);

    var speed = parseFloat(opts.speed || '1');
    var x = -7;
    function resize() { var w = canvas.clientWidth, h = canvas.clientHeight; if (w && h && (canvas.width !== w || canvas.height !== h)) { renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix(); } }
    var running = false, raf = null;
    function frame() {
      resize();
      x += 0.03 * speed; if (x > 7.5) x = -7.5;
      car.position.x = x; shadow.position.x = x + 0.3;
      var t = Date.now() * 0.004;
      (car.userData.wheels || []).forEach(function (w) { w.rotation.z -= 0.25 * speed; });
      puffs.forEach(function (s, i) { s.material.opacity = 0.3 + 0.2 * Math.abs(Math.sin(t + i)); });
      renderer.render(scene, camera);
      raf = requestAnimationFrame(frame);
    }
    return {
      start: function () { if (!running) { running = true; frame(); } },
      stop: function () { running = false; if (raf) cancelAnimationFrame(raf); raf = null; },
      once: function () { resize(); car.position.x = 0.4; shadow.position.x = 0.7; renderer.render(scene, camera); }
    };
  }

  function initSection(el) {
    var canvas = el.querySelector('[data-drift-canvas]'); if (!canvas) return;
    var opts = { car: el.getAttribute('data-car'), rim: el.getAttribute('data-rim'), speed: el.getAttribute('data-speed') };
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    loadThree(function () {
      var s = initScene(canvas, opts);
      if (reduce) { s.once(); return; }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) s.start(); else s.stop(); }); }, { threshold: 0.05 });
        io.observe(el);
      } else { s.start(); }
    });
  }

  function boot() { document.querySelectorAll('[data-drift]').forEach(initSection); }
  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sec=document.querySelector('[data-pdp]'); if(!sec) return;
  var variants=[]; try{variants=JSON.parse(sec.querySelector('[data-variants]').textContent);}catch(e){}
  var mainImg=sec.querySelector('[data-main-image]');
  var quoteEls=sec.querySelectorAll('[data-quote]');
  var email=sec.getAttribute('data-quote-email')||'';
  var title=sec.getAttribute('data-quote-title')||'';
  var purl=sec.getAttribute('data-quote-url')||'';
  function selected(){var o=[];sec.querySelectorAll('.pdp-opt').forEach(function(x){var a=x.querySelector('.pdp-sw.is-active');o.push(a?a.getAttribute('data-opt-value'):null);});return o;}
  function match(o){if(!o.length)return variants[0];return variants.find(function(v){return v.options.every(function(val,i){return !o[i]||o[i]===val;});});}
  function updateQuote(){
    var sel=selected().filter(Boolean).join(' / ');
    var subj='Quote Request - '+title+(sel?' ('+sel+')':'');
    var body='Hello Velox Hobby,%0D%0A%0D%0AI would like to request a quote for:%0D%0A'+title+(sel?' - '+sel:'')+'%0D%0A'+purl+'%0D%0A%0D%0AQuantity:%0D%0AName:%0D%0APhone:';
    var href='mailto:'+email+'?subject='+encodeURIComponent(subj)+'&body='+body;
    for(var i=0;i<quoteEls.length;i++) quoteEls[i].setAttribute('href',href);
  }
  sec.querySelectorAll('.pdp-opt').forEach(function(o){o.querySelectorAll('.pdp-sw').forEach(function(sw){sw.addEventListener('click',function(){o.querySelectorAll('.pdp-sw').forEach(function(x){x.classList.remove('is-active');});sw.classList.add('is-active');var l=o.querySelector('[data-opt-selected]');if(l)l.textContent=sw.getAttribute('data-opt-value');var v=match(selected());if(v&&v.featured_image&&mainImg){mainImg.src=v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i,'_1200x$1$2');}updateQuote();});});});
  sec.querySelectorAll('[data-thumb]').forEach(function(t){t.addEventListener('click',function(){sec.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.remove('is-active');});t.classList.add('is-active');if(mainImg)mainImg.src=t.getAttribute('data-src');});});
  var sticky=sec.querySelector('[data-sticky]'),anchor=sec.querySelector('.pdp-quotewrap');
  if(sticky&&anchor&&'IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){sticky.classList.toggle('is-visible',!e.isIntersecting);});},{threshold:0});io.observe(anchor);}
  updateQuote();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showroom"] && !Shopify.designMode) return;
  try {
    
(function () {
  var NS="http://www.w3.org/2000/svg";
  function initShow(sec){
    if (sec.dataset.vshowReady==='1') return; sec.dataset.vshowReady='1';
    var btns=[].slice.call(sec.querySelectorAll('.vshow__fbtn'));
    var svg=sec.querySelector('[data-radial]');
    var accent=(getComputedStyle(sec).getPropertyValue('--vs-accent').trim())||'#E11B2E';
    var titleEl=sec.querySelector('[data-p-title]'),descEl=sec.querySelector('[data-p-desc]'),
        specsEl=sec.querySelector('[data-p-specs]'),ctaEl=sec.querySelector('[data-p-cta]'),bannerText=sec.querySelector('[data-banner-text]');
    if(!btns.length||!svg) return;
    var cx=150,cy=150,r1=64,r2=132,gap=0.05,n=btns.length;
    function po(r,a){return (cx+r*Math.cos(a))+' '+(cy+r*Math.sin(a));}
    function seg(a0,a1){var large=(a1-a0)>Math.PI?1:0;return 'M'+po(r2,a0)+' A'+r2+' '+r2+' 0 '+large+' 1 '+po(r2,a1)+' L'+po(r1,a1)+' A'+r1+' '+r1+' 0 '+large+' 0 '+po(r1,a0)+' Z';}
    var segEls=[];
    btns.forEach(function(btn,i){
      var a0=-Math.PI/2+i*(2*Math.PI/n)+gap,a1=-Math.PI/2+(i+1)*(2*Math.PI/n)-gap,mid=(a0+a1)/2;
      var path=document.createElementNS(NS,'path');path.setAttribute('d',seg(a0,a1));path.setAttribute('class','seg');path.setAttribute('fill','#171a24');svg.appendChild(path);segEls.push(path);
      var lr=(r1+r2)/2,tx=cx+lr*Math.cos(mid),ty=cy+lr*Math.sin(mid);
      var t1=document.createElementNS(NS,'text');t1.setAttribute('class','seglabel');t1.setAttribute('x',tx);t1.setAttribute('y',ty-4);t1.textContent='EXPLORE';svg.appendChild(t1);
      var t2=document.createElementNS(NS,'text');t2.setAttribute('class','seglabel');t2.setAttribute('x',tx);t2.setAttribute('y',ty+11);t2.textContent=(btn.getAttribute('data-title')||'').toUpperCase();svg.appendChild(t2);
      path.addEventListener('click',function(){select(i);});
    });
    var c=document.createElementNS(NS,'circle');c.setAttribute('cx',cx);c.setAttribute('cy',cy);c.setAttribute('r',r1-6);c.setAttribute('fill','#0e1016');svg.appendChild(c);
    var tri=document.createElementNS(NS,'path');tri.setAttribute('d','M150 120 L172 160 L128 160 Z');tri.setAttribute('fill',accent);svg.appendChild(tri);
    function select(i){var b=btns[i];
      titleEl.textContent=b.getAttribute('data-title');descEl.textContent=b.getAttribute('data-desc');
      bannerText.textContent='Explore '+b.getAttribute('data-title');
      ctaEl.textContent=(b.getAttribute('data-cta')||('See '+b.getAttribute('data-title')))+' →';ctaEl.setAttribute('href',b.getAttribute('data-cta-link')||'#');
      specsEl.innerHTML='';(b.getAttribute('data-specs')||'').split(';').forEach(function(s){var kv=s.split('|');if(kv[0]&&kv[0].trim()){var row=document.createElement('div');row.innerHTML='<span>'+kv[0]+'</span><b>'+(kv[1]||'')+'</b>';specsEl.appendChild(row);}});
      btns.forEach(function(x,xi){x.classList.toggle('is-active',xi===i);});
      segEls.forEach(function(s,si){s.setAttribute('fill',si===i?accent:'#171a24');});
    }
    btns.forEach(function(b,i){b.addEventListener('click',function(){select(i);});});
    select(0);
  }
  function boot(){document.querySelectorAll('[data-vshow]').forEach(initShow);}
  if(document.readyState!=='loading'){boot();}else{document.addEventListener('DOMContentLoaded',boot);}
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVideoHero(hero) {
    var video = hero.querySelector('[data-bg-video]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var small = window.matchMedia('(max-width: 749px)').matches;
    var conn = navigator.connection || {};
    var saveData = conn.saveData || /2g/.test(conn.effectiveType || '');
    var allow = !reduce && !saveData;   // play on mobile too (muted inline)
    if (!('IntersectionObserver' in window)) { hero.classList.add('is-active'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          hero.classList.add('is-active');
          if (video && allow) {
            if (!video.src) { video.src = video.getAttribute('data-src'); }
            var p = video.play();
            if (p && p.then) { p.then(function(){ video.classList.add('is-playing'); }).catch(function(){}); }
            else { video.classList.add('is-playing'); }
          }
        } else if (video && !video.paused) { video.pause(); }
      });
    }, { threshold: 0.25 });
    io.observe(hero);
  }
  function boot(){ document.querySelectorAll('[data-video-hero]').forEach(initVideoHero); }
  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();
})();
